import React from "react";
import {
  Box,
  TextField,
  Select,
  InputLabel,
  FormControl,
  InputAdornment,
} from "@mui/material";

const svgImages = {
  // Small size for things like filters (277px width)
  small: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='277' height='60' viewBox='0 0 277 60' fill='none'%3E%3Cpath d='M1.09421 1.83664L45.8274 2.66169L46.0221 2.66485L46.2136 2.65853L90.9091 1L67.6339 2.66169L67.7595 2.66275L67.8851 2.65959L102.529 1.79028L140.275 2.22546H140.397L154.846 1.78923H274.389V18.6043L272.844 40.4174L272.841 40.4491L272.847 40.4806L276 43.7624L274.474 57.6397H236.455L216.854 58.0822H216.813L216.775 58.0833L176.552 59L138.705 58.5258H138.655L146.69 57.6397H146.587L134.48 58.3193L96.7972 57.6407L96.5899 57.6365L96.3827 57.645L64.0064 58.9969L1 57.6881V40.4627L3.47139 23.8918L3.47768 23.8549L3.47139 23.8169L1.09421 1.83664Z' fill='black' stroke='%23B1B1B1' stroke-width='1.8638'/%3E%3C/svg%3E")`,

  // Medium size for most inputs (780px width)
  medium: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='780' height='60' viewBox='0 0 780 60' fill='none'%3E%3Cpath d='M1.05105 1.64912L25.2898 2.28924L25.3953 2.2917L25.4991 2.28679L49.7174 1L624.546 2.28924L624.614 2.29006L624.682 2.28761L643.454 1.61315L663.906 1.95079H663.973L703.323 1.61233H778.127V14.6585L777.29 31.5825L777.288 31.607L777.292 31.6315L779 47.1777L778.173 57.9446H757.572L736.922 58.2879H736.9L736.88 58.2888L715.084 59L694.577 58.6321H694.55L111.464 57.9446H111.408L73.3266 58.4719L52.9078 57.9454L52.7956 57.9421L52.6832 57.9487L35.1401 58.9976L1 57.9822V31.6176L2.33913 18.7608L2.34253 18.7322L2.33913 18.7028L1.05105 1.64912Z' fill='black' stroke='%23474747' stroke-width='1.8638'/%3E%3C/svg%3E")`,

  // Large size for full inputs (1285px width)
  large: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1285' height='60' viewBox='0 0 1285 60' fill='none'%3E%3Cpath d='M1.08418 1.64912L41.0563 2.28924L41.2303 2.2917L41.4015 2.28679L81.3399 1L1029.29 2.28924L1029.4 2.29006L1029.51 2.28761L1060.47 1.61315L1094.2 1.95079H1094.31L1159.2 1.61233H1282.56V14.6585L1281.18 31.5825L1281.18 31.607L1281.18 31.6315L1284 47.1777L1282.64 57.9446H1248.66L1214.61 58.2879H1214.57L1214.54 58.2888L1178.6 59L1144.78 58.6321H1144.73L183.166 57.9446H183.073L120.274 58.4719L86.6012 57.9454L86.416 57.9421L86.2309 57.9487L57.3005 58.9976L1 57.9822V31.6176L3.20836 18.7608L3.21397 18.7322L3.20836 18.7028L1.08418 1.64912Z' fill='black' stroke='%23B1B1B1' stroke-width='1.8638'/%3E%3C/svg%3E")`,

  // XL size for full screen (1593px width)
  xlarge: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1593' height='60' viewBox='0 0 1593 60' fill='none'%3E%3Cpath d='M1.10439 1.64912L50.6723 2.28924L50.8881 2.2917L51.1003 2.28679L100.626 1L1276.14 2.28924L1276.28 2.29006L1276.42 2.28761L1314.81 1.61315L1356.64 1.95079H1356.77L1437.24 1.61233H1590.21V14.6585L1588.5 31.5825L1588.5 31.607L1588.51 31.6315L1592 47.1777L1590.31 57.9446H1548.18L1505.95 58.2879H1505.91L1505.86 58.2888L1461.29 59L1419.36 58.6321H1419.3L226.897 57.9446H226.782L148.907 58.4719L107.151 57.9454L106.921 57.9421L106.692 57.9487L70.8161 58.9976L1 57.9822V31.6176L3.7385 18.7608L3.74546 18.7322L3.7385 18.7028L1.10439 1.64912Z' fill='black' stroke='%23474747' stroke-width='1.8638'/%3E%3C/svg%3E")`,

  // Textarea for multiline (1593x177px)
  textarea: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1593' height='177' viewBox='0 0 1593 177' fill='none'%3E%3Cpath d='M1.10439 2.95818L50.6723 4.88922L50.8881 4.89662L51.1003 4.88182L100.626 1L1276.14 4.88922L1276.28 4.89169L1276.42 4.88429L1314.81 2.84966L1356.64 3.86821H1356.77L1437.24 2.8472H1590.21V42.2031L1588.5 93.2572L1588.5 93.3312L1588.51 93.4051L1592 140.303L1590.31 172.783H1548.18L1505.95 173.819H1505.91L1505.86 173.821L1461.29 175.967L1419.36 174.857H1419.3L226.897 172.783H226.782L148.907 174.373L107.151 172.785L106.921 172.775L106.692 172.795L70.8161 175.959L1 172.896V93.3632L3.7385 54.5785L3.74546 54.4922L3.7385 54.4034L1.10439 2.95818Z' fill='black' stroke='%23474747' stroke-width='1.8638'/%3E%3C/svg%3E")`,
};

const CustomShapedInput = ({
  component = "TextField",
  label,
  value,
  onChange,
  placeholder,
  startAdornment,
  endAdornment,
  children,
  fullWidth = true,
  multiline = false,
  rows = 1,
  sx = {},
  variant = "outlined",
  size = "medium",
  svgSize = "normal",
  ...props
}) => {
  let backgroundImage = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1285' height='60' viewBox='0 0 1285 60' fill='none'%3E%3Cpath d='M1.08418 1.64912L41.0563 2.28924L41.2303 2.2917L41.4015 2.28679L81.3399 1L1029.29 2.28924L1029.4 2.29006L1029.51 2.28761L1060.47 1.61315L1094.2 1.95079H1094.31L1159.2 1.61233H1282.56V14.6585L1281.18 31.5825L1281.18 31.607L1281.18 31.6315L1284 47.1777L1282.64 57.9446H1248.66L1214.61 58.2879H1214.57L1214.54 58.2888L1178.6 59L1144.78 58.6321H1144.73L183.166 57.9446H183.073L120.274 58.4719L86.6012 57.9454L86.416 57.9421L86.2309 57.9487L57.3005 58.9976L1 57.9822V31.6176L3.20836 18.7608L3.21397 18.7322L3.20836 18.7028L1.08418 1.64912Z' fill='black' stroke='%23B1B1B1' stroke-width='1.8638'/%3E%3C/svg%3E")`;
  if (svgSize !== "normal" && svgImages[svgSize]) {
    backgroundImage = svgImages[svgSize];
  }
  // SVG path as background for all inputs
  const svgBackground = {
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage, //: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1285' height='60' viewBox='0 0 1285 60' fill='none'%3E%3Cpath d='M1.08418 1.64912L41.0563 2.28924L41.2303 2.2917L41.4015 2.28679L81.3399 1L1029.29 2.28924L1029.4 2.29006L1029.51 2.28761L1060.47 1.61315L1094.2 1.95079H1094.31L1159.2 1.61233H1282.56V14.6585L1281.18 31.5825L1281.18 31.607L1281.18 31.6315L1284 47.1777L1282.64 57.9446H1248.66L1214.61 58.2879H1214.57L1214.54 58.2888L1178.6 59L1144.78 58.6321H1144.73L183.166 57.9446H183.073L120.274 58.4719L86.6012 57.9454L86.416 57.9421L86.2309 57.9487L57.3005 58.9976L1 57.9822V31.6176L3.20836 18.7608L3.21397 18.7322L3.20836 18.7028L1.08418 1.64912Z' fill='black' stroke='%23B1B1B1' stroke-width='1.8638'/%3E%3C/svg%3E")`,
      backgroundSize: "100% 100%",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      zIndex: -1,
    },
  };

  // Common styles for both TextField and Select
  const commonStyles = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "transparent",
      height: component === "TextField" && !multiline ? "60px" : "auto",
      color: "white",
      "& fieldset": {
        border: "none", // Remove default border as we use the SVG
      },
    },
    "& .MuiInputLabel-root": {
      color: "#D9D9D9",
      marginTop: "4px",
      "&.Mui-focused": {
        color: "white",
      },
    },
    "& .MuiInputBase-input": {
      paddingLeft: "20px",
    },
    "& .MuiSelect-icon": {
      color: "white",
    },
    ...sx,
  };

  // Render TextField
  if (component === "TextField") {
    return (
      <Box sx={svgBackground}>
        <TextField
          label={label}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          fullWidth={fullWidth}
          multiline={multiline}
          rows={rows}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            startAdornment: startAdornment && (
              <InputAdornment position="start">{startAdornment}</InputAdornment>
            ),
            endAdornment: endAdornment && (
              <InputAdornment position="end">{endAdornment}</InputAdornment>
            ),
          }}
          sx={commonStyles}
          variant={variant}
          size={size}
          {...props}
        />
      </Box>
    );
  }

  // Render Select
  if (component === "Select") {
    return (
      <Box sx={svgBackground}>
        <FormControl fullWidth={fullWidth} size={size} sx={commonStyles}>
          {label && <InputLabel>{label}</InputLabel>}
          <Select
            value={value}
            onChange={onChange}
            label={label}
            startAdornment={
              startAdornment && (
                <InputAdornment position="start">
                  {startAdornment}
                </InputAdornment>
              )
            }
            endAdornment={
              endAdornment && (
                <InputAdornment position="end">{endAdornment}</InputAdornment>
              )
            }
            {...props}
          >
            {children}
          </Select>
        </FormControl>
      </Box>
    );
  }

  // Render raw input (for search)
  if (component === "InputBox") {
    return (
      <Box
        sx={{
          ...svgBackground,
          display: "flex",
          alignItems: "center",
          padding: "0 15px",
          height: "60px",
          width: fullWidth ? "100%" : "auto",
          ...sx,
        }}
      >
        {startAdornment && <Box sx={{ mr: 1 }}>{startAdornment}</Box>}
        <input
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={{
            border: "none",
            background: "transparent",
            width: "100%",
            color: "white",
            fontSize: "16px",
            outline: "none",
            height: "46px",
          }}
          {...props}
        />
        {endAdornment && <Box sx={{ ml: 1 }}>{endAdornment}</Box>}
      </Box>
    );
  }

  return null;
};

export default CustomShapedInput;
